export const SAVE_FILE_DATA_REQUEST = "SAVE_FILE_DATA_REQUEST";
export const SAVE_FILE_DATA_SUCCESS = "SAVE_FILE_DATA_SUCCESS";
export const SAVE_FILE_DATA_FAIL = "SAVE_FILE_DATA_FAIL";
export const SAVE_FILE_DATA_RESET = "SAVE_FILE_DATA_RESET";